import { render } from "./BioChemicalGeneticsGlobal.vue?vue&type=template&id=858a79ba"
import script from "./BioChemicalGeneticsGlobal.vue?vue&type=script&lang=js"
export * from "./BioChemicalGeneticsGlobal.vue?vue&type=script&lang=js"

import "./BioChemicalGeneticsGlobal.vue?vue&type=style&index=0&id=858a79ba&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__